import DairyService from '@src/api/services/dairy';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { StateEl } from '../style';
import { FormFields } from '@src/components/FormFields';
import { GlobalEl } from '@src/styles/app';
import DairyQuery from '@src/QueryHooks/DairyQuery';
import notify from '~/components/Notify';
import { useMutation } from 'react-query';
import Drawer from '~/components/Drawer';

interface CreateEditMilkTypeProps {
  isVisible: boolean;
  handleHiddenDrawer: () => void;
  isLoading?: boolean;
  fetchData?: () => void,
  idAssociation?: any
}

const CreateEditAssociations: React.FunctionComponent<CreateEditMilkTypeProps> = (props) => {
  const { isVisible, handleHiddenDrawer, idAssociation } = props;
  const { t } = useTranslation();
  const { handleSubmit, control, reset, formState } = useForm({
    mode: 'onSubmit'
  });

  useEffect(() => {
    if (idAssociation) {
      editAssociation(idAssociation);
    } else {
      reset({
        name: '',
        abbreviation: ''
      });
    }
  }, [isVisible, idAssociation]);
  const onSuccess = () => {
    notify(t('Successfully created association'), 'success');
    props.fetchData()
  };

  const onAssociationSuccess = (response) => {
    reset(response.data)
  }

  const { mutateAsync: storeAssociation } =
    DairyQuery.storeAssociation(onSuccess);

  const { mutate: updateAssociation } = useMutation(
    'associations-update',
    DairyService.updateAssociation,
    {
      onSuccess: () => {
        notify(t('Successfully updated association'), 'success');
        props.fetchData()
      }
    }
  );

  const { isLoading: isAssociationLoading, mutateAsync: editAssociation } =
    DairyQuery.editAssociation(onAssociationSuccess);

  const onSubmit = (data) => {
    if (!idAssociation) {
      storeAssociation({ ...data });
    } else {
      updateAssociation({ id: idAssociation, data })
    }
    handleHiddenDrawer();
  };

  const renderContent = () => {
    return (
      <>
        <FormFields.Input
          control={control}
          name={'name'}
          label={t('Association name')}
          placeholder={t('Association name')}
          rules={{
            required: {
              value: true,
              message: t('Please enter Association name')
            }
          }}
        />
        <FormFields.Input
          control={control}
          label={t('Association abbreviation')}
          placeholder={t('Association abbreviation')}
          name={'abbreviation'}
          rules={{
            required: {
              value: true,
              message: t('Please enter Association abbreviation')
            },
            maxLength: {
              value: 20,
              message: t('Max. 20 characters')
            }
          }}
        />
        <StateEl.DrawerFooter>
          <GlobalEl.PrimaryButton
            disabled={Object.keys(formState.dirtyFields).length === 0}
          >{idAssociation ? t('Update') : t('Add')}</GlobalEl.PrimaryButton>
        </StateEl.DrawerFooter>
      </>
    );
  };

  return <Drawer
    isVisible={isVisible}
    handleSubmit={handleSubmit(onSubmit)}
    isBusy={isAssociationLoading}
    header={idAssociation ? t('Edit association') : t('Create association')}
    closeOnEscape
    onHide={() => {
      reset();
      handleHiddenDrawer();
    }}
    content={renderContent()}
  />
};

export default CreateEditAssociations;
